import {singleton} from "../../infrastructure/decorators/singleton";
import {BaseTerms} from "../../infrastructure/models/base-terms";

@singleton
export class LanguageMenuModuleTerms extends BaseTerms {
  WEB_SETTING_LANGUAGES_ALL = 'All Languages';
  WEB_SETTING_LANGUAGES_COMMON = 'Common Languages in your area';
  WEB_LANG_MENU_HEADER = 'Selected Language';
  WEB_LANG_MENU_MORE_BUTTON = 'More';
  WEB_LANG_MENU_LESS_BUTTON = 'Less';
}
